import { useModals } from "@/providers/ModalProvider";
import { hasOpenModalInDom } from "@/lib/utils/modalSideEffectCleanup";
import { useCallback } from "react";

export function useHasBlockingModalOpen() {
  const { activeSlideovers } = useModals();

  return useCallback(() => {
    if (activeSlideovers.some((slideover) => slideover.isOpen)) {
      return true;
    }

    return hasOpenModalInDom();
  }, [activeSlideovers]);
}
